/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";

export type RedeployResult = {
  deployment?: Deployment | undefined;
};

/** @internal */
export const RedeployResult$inboundSchema: z.ZodMiniType<
  RedeployResult,
  unknown
> = z.object({
  deployment: z.optional(Deployment$inboundSchema),
});

export function redeployResultFromJSON(
  jsonString: string,
): SafeParseResult<RedeployResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RedeployResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RedeployResult' from JSON`,
  );
}
